import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import driverLoadApi from '../../../api/driverLoads/driverLoadsApi';
import { IAttachmentByDriverLoadInitialState } from '../interfaces';
import { IAssociateAttachment } from '../../Driver/DriverDetails/interfaces/IAssociateAttachment';

export const fetchAttachmentByDriverLoad = createAsyncThunk(
    'fetchAttachmentByDriverLoad',
    async ({ shipmentId }: { shipmentId: number }, { rejectWithValue }) => {
        try {
            const response = await driverLoadApi.fetchAttachmentByDriverLoad(
                shipmentId,
            );

            return response;
        } catch {
            return rejectWithValue('Error');
        }
    },
);

const initialState: IAttachmentByDriverLoadInitialState = {
    loading: false,
    attachmentList: [],
};

export const attachmentByDriverLoadSlice = createSlice({
    name: 'fetchAttachmentByDriverLoad',
    initialState,
    reducers: {
        setAttachmentList: (
            state,
            action: PayloadAction<IAssociateAttachment[]>,
        ) => {
            state.attachmentList = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchAttachmentByDriverLoad.pending, state => {
            state.loading = true;
            state.attachmentList = [];
        });
        builder.addCase(
            fetchAttachmentByDriverLoad.fulfilled,
            (state, action) => {
                state.loading = false;
                state.attachmentList = action.payload;
            },
        );
        builder.addCase(fetchAttachmentByDriverLoad.rejected, state => {
            state.loading = false;
        });
    },
});

export const { setAttachmentList } = attachmentByDriverLoadSlice.actions;

const AttachmentByDriverLoadReducer = attachmentByDriverLoadSlice.reducer;
export default AttachmentByDriverLoadReducer;
